export function getFormattedPhoneNumber(string) {
  if (!string) return string;

  const cleaned = (`${string}`).replace(/\D/g, '');
  const match = cleaned.match(/^(\d{3})(\d{3})(\d{4})$/);

  if (match) {
    return `(${match[1]}) ${match[2]}-${match[3]}`;
  }

  return null;
}

export function removePhoneNumberFormat(string) {
  if (!string) return string;
  return (`${string}`).replace(/\D/g, '');
}
